import { Snackbar, useSnackbar } from "@hireart/component-library";
import "react-toastify/dist/ReactToastify.css";

const { showError, showSuccess, showInfo, showWarning, show } = useSnackbar();

export const Toasts = {
  error(msg) {
    return showError(msg);
  },
  success(msg) {
    return showSuccess(msg);
  },
  warning(msg) {
    return showWarning(msg);
  },
  info(msg) {
    return showInfo(msg);
  },
  neutral(msg) {
    return show(msg);
  },
  Container: Snackbar,
};
